import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AuthService from './services/authService'
import axios from 'axios'

const authService = new AuthService()
authService.start()

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  return new Promise((resolve, reject) => {
    console.log("Hit interceptors")
    if (store.getters.isAccessTokenExpired) {
      console.log('Access token expired, refreshing...')
      authService
        .refreshSession()
        .then((authResult) => {
          console.log('Auth result', authResult)
          config.headers['Authorization'] = `Bearer ${authResult.accessToken}`
          resolve(config)
        })
        .catch((err) => {
          console.error('Unable to refresh token', err)
          reject(err)
          router.push('/login')
        })
    }
    else {
      config.headers['Authorization'] = `Bearer ${store.state.userAccessToken}`
      resolve(config)
    }
  })
}, function (error) {
  // Do something with request error
  console.log("There was an error intercepting the request.")
  return Promise.reject(error)
})

import './assets/css/tailwind.css'

Vue.config.productionTip = false
Vue.prototype.$authService = authService

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
